module.exports = __webpack_public_path__ + "img/Learn_English_3.b423ebf9.jpg";